import React, { useRef, useState } from "react";
import "./FocusedVideoCardCarousel.css";
import parse from "html-react-parser";
import CustomLink from "../../utils/customLink";
import { Button } from "../Button";
import { useGetLink } from "../../utils/useOpenLink";
import { APP_COLORS } from "../../constants/styles";
import { t } from "i18next";

const FocusedVideoCardCarousel = ({
    contents: contentsArray,
    body,
    heading,
    block_buttons,
    colors: colorObj,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const videoRef = useRef(null);
    const modalVideoRef = useRef(null);
    const { getLink } = useGetLink();

    const openModal = () => {
        setIsModalOpen(true);
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        if (modalVideoRef.current) {
            modalVideoRef.current.pause();
        }
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    return (
        <>
            <section className="hero" style={APP_COLORS(colorObj)}>
                <div className="hero-container">
                    <div className="hero-content">
                        <h1 className="hero-title">{heading}</h1>

                        <p className="hero-subtitle">{parse(body)}</p>

                        <div className="hero-buttons">
                            {block_buttons.map((v) => (
                                <CustomLink to={getLink(v.action)} key={v.label}>
                                    <div className="mt-4 mb-4 text-center">
                                        <Button className="primaryBtn">
                                            <span>{v.label}</span>
                                        </Button>
                                    </div>
                                </CustomLink>
                            ))}
                        </div>
                    </div>

                    <div className="hero-image-container">
                        <div className="image-frame">
                            <div className="video-overlay" onClick={openModal}>
                                <div className="play-button">
                                    <i className="pi pi-play"></i>
                                </div>
                            </div>
                            <video
                                ref={videoRef}
                                className="hero-video"
                                loop
                                muted
                                playsInline
                                autoPlay
                                src={contentsArray[0]?.content_buttons[0]?.action}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {isModalOpen && (
                <div className="video-modal" onClick={closeModal} style={APP_COLORS(colorObj)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2 className="modal-title">{heading}</h2>
                            <button className="close-button" onClick={closeModal}>
                                {t("constantString.close")} <i className="pi pi-times"></i>
                            </button>
                        </div>
                        <div className="modal-video-container">
                            <video
                                ref={modalVideoRef}
                                className="modal-video"
                                controls
                                autoPlay
                                src={contentsArray[0]?.content_reference}
                            ></video>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FocusedVideoCardCarousel;
